import {Directive, ElementRef, Input, OnInit, NgModule,OnChanges} from '@angular/core';

@Directive({selector: '[ligth-gallery]'})
export class LigthGallery implements OnInit {

    constructor(private element: ElementRef) {
        
    }

    ngOnInit() {
        
       let element = $(this.element.nativeElement);
        
            element.parent()["lightGallery"]({
                thumbnail:true,
                animateThumb: true,
                showThumbByDefault: false
            });
            
            element.find('#no-action').on('click',function(event){
                return false;
            })
            
            element.find('#no-action').click(function(){
                return false;
            });
            element.find('.no-action').click(function(){
                return false;
            });
    }
}

@NgModule({
    declarations: [LigthGallery],
    exports: [LigthGallery],
    entryComponents:[]
})
export class LigthGalleryModule {

}